export default __webpack_public_path__ + "static/media/ic_brazil.c77d72ca.svg";